<template>
  <el-form-item v-bind="$attrs" v-on="$listeners" :prop="isReadOnly ? '' : prop">
    <div v-if="isReadOnly" class="value">
      <div v-if="model[prop] !== null" :style="{'width':'100%', 'background-color': model[prop]}">
        {{model[$attrs.prop] === 'white' ? '白' : '&nbsp;'}}
      </div>
      <div v-else style="color: darkgrey; font-weight: bold">空</div>
    </div>
    <color-select v-else v-model="model[prop]"></color-select>
  </el-form-item>
</template>

<script>
  import ColorSelect from '@/components/selector/ColorSelect'

  export default {
    name: 'ColorFormItem',
    components: { ColorSelect },
    props: {
      readOnly: {
        type: Boolean,
        default: null
      },
      prop: String
    },
    computed: {
      isReadOnly () {
        if (this.readOnly !== null) return this.readOnly
        let parent = this.$parent
        while (parent) {
          if (parent.controlReadOnly != null) return parent.controlReadOnly
          parent = parent.$parent
        }
        return null
      },
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
